import {ViewType} from "../../../gd/const/views/view-type"
import ProjectLocalSettings from "../../../manager/project/project-local-settings"
import {projectViews_createProjectViewFromConfig} from "../actions/create"
import ProjectViews from "../project-views"

// const debug = "projectViews_getProjectDefaultView"
const debug = false

export default function projectViews_getProjectDefaultView(projectViews: ProjectViews, options?: {
    fallbackViewType?   : ViewType // specifies a view type to use as a fallback, if no default view is determined by other logic or inputs
    checkLocalSettings? : boolean
}){
    const fallbackViewType      = _.get(options, 'fallbackViewType', ViewType.PROJECT_NO_VIEWS)
    const checkLocalSettings    = _.get(options, 'checkLocalSettings', gd.user.clientData.labs.navigation.projectGoToRecentView)

    // get default view considering that no system views available

    debug && console.log(debug, "getDefaultView()")
    const firstView = projectViews.getFirst()

    // there is only one view for Page or Embed project
    if ((projectViews.project.isPage || projectViews.project.isEmbed) && firstView) {
        return firstView
    }

    // for workspaces if fallback is ViewType.PROJECT_NO_VIEWS display "No Views" instead of
    // defaulting to the first available view
    if (projectViews.project.isWorkspace && fallbackViewType === ViewType.PROJECT_NO_VIEWS) {
        return projectViews_createProjectViewFromConfig(projectViews, {
            systemType: fallbackViewType
        })
    }

    const defaultViewId: ID | null = projectViews_getProjectDefaultViewId(projectViews.project.id, checkLocalSettings)
    debug && console.log(debug,"getDefaultView defaultViewId=", defaultViewId)

    let defaultView = defaultViewId ? projectViews.get(defaultViewId) : null
    debug && console.log(debug,"getDefaultView defaultView=", defaultView)

    // take first if any
    if (!defaultView && firstView) {
        defaultView = firstView
        debug && console.log(debug,"getDefaultView first", defaultView);
    }

    // if there is no views create fallbackViewType (ViewType.PROJECT_NO_VIEWS) view to display
    if (!defaultView) {
        defaultView = projectViews_createProjectViewFromConfig(projectViews, {
            systemType: fallbackViewType
        })
    }
    debug && console.log(debug,"getDefaultView done", defaultView, projectViews.models)

    return defaultView
}

function projectViews_getProjectDefaultViewId(projectId: ID, checkLocalSettings = true): ID | null{
    /*** KNOWN ISSUE
     * on mozet vernut' parent view kotori ne dolzen inherite ... naprimer discussions
     * ne smog legko ispravit'.... sdelal patch
     *
     */

    const project = gd.session.projects.get(projectId)!

    let localSettingsDefaultView

    // check localSettings
    if (checkLocalSettings) {
        localSettingsDefaultView = _getDefaultViewFromLocalSettings(projectId)
        if (localSettingsDefaultView) {
            debug && console.log(debug,"initialized from local settings =", localSettingsDefaultView)
            return localSettingsDefaultView
        }
    }

    // check if we have it set for this project
    // there may be no settings for project (settings: null)
    if (project.settings?.defaultView) {
        debug && console.log(debug,"initialized from project settings =", localSettingsDefaultView);
        return project.settings.defaultView
    }

    // check parents
    // Ok eto hitro - tut mi berem parent on svoi parent ... recursion. last one always will take company default I guess
    // Parent may be absent in gd.session.projects then no recursive settings search available
    if (gd.session.projects.get(project.parentId)) {
        const parentProjectDefaultView:any = projectViews_getProjectDefaultViewId(project.parentId!, checkLocalSettings)
        if (parentProjectDefaultView) {
            // patch (exclude PROJECT_MEETINGS and PROJECT_EXPENSES)
            if (![
                ViewType.PROJECT_MEETINGS,
                ViewType.PROJECT_EXPENSES,
            ].includes(parentProjectDefaultView)) {
                return parentProjectDefaultView
            }
        }
    }

    return null
}

function _getDefaultViewFromLocalSettings(projectId: ID) {
    const localSettings = new ProjectLocalSettings(projectId);
    return localSettings.defaultView;
}
